import { render, staticRenderFns } from "./main-stock.vue?vue&type=template&id=6bd3c127&scoped=true&"
import script from "./main-stock.vue?vue&type=script&lang=js&"
export * from "./main-stock.vue?vue&type=script&lang=js&"
import style0 from "./main-stock.vue?vue&type=style&index=0&id=6bd3c127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd3c127",
  null
  
)

export default component.exports